import { AdminService } from './../../../services/admin.service';
import { Menu, Role } from './../../../models';
import { AuthService } from './../../../services/auth.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { IndividualMenu, EmployeeMenu, ManagerMenu, AdministratorMenu } from '../../../helpers/menus';
import { UserNavigationComponent } from 'src/app/partials/navigation/user-navigation/user-navigation.component';
import * as jquery from 'jquery';
import { map, tap } from 'rxjs/operators';
import { UserService } from 'src/app/services/user.service';

declare var require: any;

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {

  @ViewChild(UserNavigationComponent) userNavigation;

  user: any;
  fullname: string;
  avatar: string;
  error = false;
  preloaderImage = require('../../../../assets/images/loader-big.svg');
  menus: Menu[] = [];
  modalText = 'Loading...';
  nonAdminRoles = [Role.Individual, Role.Manager, Role.Employee];

  constructor(
    public authService: AuthService,
    private route: ActivatedRoute,
    private pageTitleService: Title,
    private userService: UserService,
    private adminService: AdminService
  ) { }

  ngOnInit(): void {
    this.setPageTitle();
    this.setMenus();

    const currentRole = this.authService.currentUserValue.role;
    if (currentRole && this.nonAdminRoles.indexOf(currentRole) >= 0) {
      this.loadData();
    } else {
      this.authService.getTokenDetails(this.authService.tokenValue)
        .subscribe(response => {
          if (response && response.data.role === Role.Admin) {
            this.loadAdminData();
          } else {
            this.loadData();
          }
        });
    }

    let top = document.getElementById('top');
    if (top !== null) {
      top.scrollIntoView();
      top = null;
    }

  }

  setPageTitle() {
    this.pageTitleService.setTitle(this.route.snapshot.data.title || 'Profile');
  }

  setMenus() {
    const currentRole = this.authService.currentUserValue.role;

    // Individual
    if (currentRole && currentRole === Role.Individual) {
      this.menus = IndividualMenu;
      return;
    } else {
      this.authService.getTokenDetails(this.authService.tokenValue)
        .subscribe(response => {
          if (response.data.role === Role.Individual) {
            this.menus = IndividualMenu;
            return;
          }
        });
    }

    // Employee
    if (currentRole && currentRole === Role.Employee) {
      this.menus = EmployeeMenu;
      return;
    } else {
      this.authService.getTokenDetails(this.authService.tokenValue)
        .subscribe(response => {
          if (response.data.role === Role.Employee) {
            this.menus = EmployeeMenu;
            return;
          }
        });
    }

    // Manager
    if (currentRole && currentRole === Role.Manager) {
      this.menus = ManagerMenu;
      return;
    } else {
      this.authService.getTokenDetails(this.authService.tokenValue)
        .subscribe(response => {
          if (response.data.role === Role.Manager) {
            this.menus = ManagerMenu;
            return;
          }
        });
    }

    // Administrator
    if (currentRole && currentRole === Role.Admin) {
      this.menus = AdministratorMenu;
      return;
    } else {
      this.authService.getTokenDetails(this.authService.tokenValue)
        .subscribe(response => {
          if (response && response.data.role === Role.Admin) {
            this.menus = AdministratorMenu;
            return;
          }
        });
    }

  }

  loadData() {

    // Show progress modal
    this.showProgressModal();

    this.userService.getProfile()
      .pipe(

        // Get User Details
        map(user => user.data.user),
        tap(user => {
          this.userNavigation.user = user;
          this.user = user;
          this.fullname = this.user?.first_name + ' ' + this.user?.last_name;
        }),

      )
      .subscribe(
        response => {
          if (response) {
            setTimeout(() => {
              // hide progress modal
              this.hideProgressModal();
            }, 500);
          }
        },
        error => {
          // hide progress modal
          this.hideProgressModal();
          this.error = true;
        }
      );
  }

  loadAdminData() {

    // Show progress modal
    this.showProgressModal();

    this.adminService.getProfile()
      .pipe(

        // Get User Details
        map(user => user.data.user),
        tap(user => {
          this.userNavigation.user = user;
          this.user = user;
          this.fullname = this.user?.first_name + ' ' + this.user?.last_name;
        }),

      )
      .subscribe(
        response => {
          if (response) {
            setTimeout(() => {
              // hide progress modal
              this.hideProgressModal();
            }, 500);
          }
        },
        error => {
          // hide progress modal
          this.hideProgressModal();
          this.error = true;
        }
      );
  }

  private showProgressModal() {
    jquery('#loaderSpin').show();
  }

  private hideProgressModal() {
    jquery('#loaderSpin').hide();
  }


}
